import { z } from 'zod';

import { T } from 'Features/SellerCommunications/utils/translate';
import { SellerCommunicationStatus } from 'Pages/api/seller-communications/types';

export const MAX_EMAIL_BODY_LENGTH = 10000;

export const EmailBodySchema = z
	.string()
	.max(MAX_EMAIL_BODY_LENGTH, `${T.translate('createEmail.validationErrors.bodyMaxLength')}`);

export const EMAIL_VALIDATION_REGEXP = /[^\w\s\-[\]().,:;"'’!?–=~/%#@&$£*+\\]+/g;

export const TOAST_DURATION = 5000;

export const CONTACTED_STATUSES = new Set([
	SellerCommunicationStatus.DEALER_MARKED_AS_CONTACTED,
	SellerCommunicationStatus.MESSAGE_CREATION_IS_PENDING,
	SellerCommunicationStatus.MESSAGE_HAS_BEEN_CREATED,
]);

export const CANCELED_STATUSES = new Set([SellerCommunicationStatus.SALE_CANCELLED]);

export const ERROR_STATUSES = new Set([
	SellerCommunicationStatus.FAILED_TO_CREATE_MESSAGE,
	SellerCommunicationStatus.NO_MESSAGE_HAS_BEEN_CREATED,
]);

export const SELLER_COMMUNICATION_ERROR_GROUPS = [
	{ statuses: CONTACTED_STATUSES, type: 'contacted' },
	{ statuses: CANCELED_STATUSES, type: 'cancelled' },
	{ statuses: ERROR_STATUSES, type: 'error' },
];
